import React from "react";
import { useLocation } from "react-router-dom";
import { useTenant } from "../TenantContext";
import { isPathAllowedForTenant } from "../guards";
import ForbiddenPage from "./ForbiddenPage";

/**
 * Capability + kind route guard. Blocks direct URL access; does not
 * silently redirect away authorization failures.
 */
export default function CapabilityRoute({ children }) {
  const { tenant } = useTenant();
  const location = useLocation();
  const decision = isPathAllowedForTenant(tenant, location.pathname);

  if (!decision.allowed) {
    return (
      <ForbiddenPage
        reason={decision.reason}
        detail={
          decision.capability
            ? `Missing capability: ${decision.capability}`
            : undefined
        }
      />
    );
  }

  return children;
}
